import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class GetDocumentService {

  constructor(
    private http: HttpClient,
    private occService: OccEndpointsService
  ) { }

  getDocumentByDocumentCode(documentCode: string) {
    return this.http.get(this.occService.buildUrl(`pdfDocument/latestDocument?documentCode=${documentCode}`));
  }
}
